import { Grid } from "@material-ui/core";
import React from "react";
import {
  UserName,
  ContextText,
  RenderDate,
  RenderTypeOfRequest,
  AttributeChipComponent,
  RenderAttributeText,
  RenderAttributesDetails,
  ActionCta,
  CustomDivider,
  Status,
} from "./DetailComponent";
import { DetailPageProp } from "./type";

const buildClientAttributes = (
  whatWentWell?: string,
  whatCouldBeDifferent?: string,
  overallFeedback?: string
) =>
  [
    { name: "What went well?", context: whatWentWell },
    { name: "What could have been done differently?", context: whatCouldBeDifferent },
    { name: "Overall Feedback, if any.", context: overallFeedback },
  ]
    .filter((a): a is { name: string; context: string } => !!a.context)
    .map((a) => ({ ...a, questions: [], suggestions: "", resources: "" }));

export const DetailPage: React.FC<DetailPageProp> = ({
  from,
  date,
  user,
  context,
  attributeNames,
  attributes,
  setValue,
  requestId,
  status,
  tag,
  whatWentWell,
  whatCouldBeDifferent,
  overallFeedback,
}) => {
  const isClientFeedback = tag === "EXTERNAL" && from === "RECEIVED_FEEDBACK" &&
    !!(whatWentWell || whatCouldBeDifferent || overallFeedback);

  const renderTypeOfRequest = () => (
    <>
      {from === "RECEIVED_FEEDBACK" && (
        <RenderTypeOfRequest requestId={requestId} />
      )}
    </>
  );
  const renderDate = () => <RenderDate from={from} date={date} />;
  const renderUser = () => <UserName user={user} />;
  const renderContext = () => <>{context && <ContextText text={context} />}</>;
  const hasAttributes = attributes && attributes.length > 0;
  const renderAttributesChip = () => (
    <>
      {(from === "SHARED_FEEDBACK" || (from === "SENT_REQUEST" && hasAttributes)) && (
        <AttributeChipComponent attributes={attributes} />
      )}
      {from === "RECEIVED_REQUEST" && attributeNames && (
        <AttributeChipComponent attributes={attributeNames} />
      )}
    </>
  );
  const renderAttributeHeader = () => <RenderAttributeText from={from} />;
  const renderAttributesDetail = () =>
    from !== "SENT_REQUEST" && (
      <RenderAttributesDetails attributes={attributes} />
    );
  const renderActionCta = () =>
    setValue && (
      <ActionCta from={from} userStatus={user?.status} setValue={setValue} />
    );
  const renderRequestStatus = () => status && <Status status={status} />;
  const renderDivider = () => <CustomDivider />;
  return (
    <>
      <Grid container justify="flex-start">
        {renderTypeOfRequest()}
        {renderDate()}
      </Grid>
      {renderUser()}
      {renderDivider()}
      {renderContext()}
      {context && renderDivider()}
      {renderAttributesChip()}
      {(from === "SHARED_FEEDBACK" ||
        (from === "SENT_REQUEST" && hasAttributes) ||
        from === "RECEIVED_REQUEST") &&
        renderDivider()}
      {isClientFeedback ? (
        <>
          <RenderAttributeText from={"CLIENT_FEEDBACK"} />
          <RenderAttributesDetails
            attributes={buildClientAttributes(whatWentWell, whatCouldBeDifferent, overallFeedback)}
          />
        </>
      ) : (
        <>
          {renderAttributeHeader()}
          {renderAttributesDetail()}
        </>
      )}
      {renderActionCta()}
      {renderRequestStatus()}
    </>
  );
};
